import { Injectable } from "@angular/core";
import { Product } from "../shared/product";
import { ProductConstraintsFactory } from "./product-constraints.factory";

@Injectable({
  providedIn: "root",
})
export class ProductConstraintsFacade {
  constructor(
    private readonly _productConstraintsFactory: ProductConstraintsFactory,
  ) {}

  get(product: Product) {
    const productConstraintsService =
      this._productConstraintsFactory.get(product);

    return productConstraintsService.get();
  }

  getInsuredSumConstraints(product: Product) {
    const productConstraintsService =
      this._productConstraintsFactory.get(product);

    return productConstraintsService.getInsuredSumConstraints();
  }

  getEntryAgeConstraints(product: Product) {
    const productConstraintsService =
      this._productConstraintsFactory.get(product);

    return productConstraintsService.getEntryAgeConstraints();
  }

  getBmiConstraints(product: Product) {
    const productConstraintsService =
      this._productConstraintsFactory.get(product);

    return productConstraintsService.getBmiConstraints();
  }

  getYearlyPremiumConstraints(product: Product) {
    const productConstraintsService =
      this._productConstraintsFactory.get(product);

    return productConstraintsService.getYearlyPremiumConstraints();
  }
}
